/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Csjensblank_Kommunikations_Training33Inputs */

const en__field_enum_csjensblank_kommunikations_training33 = /** @type {(inputs: _Field_Enum_Csjensblank_Kommunikations_Training33Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`communication training`)
};

const de__field_enum_csjensblank_kommunikations_training33 = /** @type {(inputs: _Field_Enum_Csjensblank_Kommunikations_Training33Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training im Bereich Kommunikationsfähigkeiten und Selbstvermarktung`)
};

/**
* | output |
* | --- |
* | "communication training" |
*
* @param {_Field_Enum_Csjensblank_Kommunikations_Training33Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_csjensblank_kommunikations_training33 = /** @type {((inputs?: _Field_Enum_Csjensblank_Kommunikations_Training33Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Csjensblank_Kommunikations_Training33Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_csjensblank_kommunikations_training33(inputs)
	return de__field_enum_csjensblank_kommunikations_training33(inputs)
});
export { _field_enum_csjensblank_kommunikations_training33 as "_field_enum_CSJENSBLANK_KOMMUNIKATIONS_TRAINING" }